import React from 'react';

const LoadingIndicator = () => {
    return (
        <div id="LoadingIndicator">
            <img alt="" src="img/pict-logo.png" />
            <svg>
                <circle></circle>
            </svg>
        </div>
    );
}

export default LoadingIndicator;